import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { ROUTING_APP_2, ROUTING_TAB_1, ROUTING_TAB_2 } from '../../constants/routing'
import { NAME_APP2 } from '../../constants/wording'

export class NavBarApp2 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const styles = {
      container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
      },
    };
    return (
      <div>
        <nav>
          <div style={styles.container} className="nav-wrapper">
            <div>
              <a href="/" className="brand-logo left">{NAME_APP2}</a>
            </div>

            <div>
              <ul>
                <li>
                  <NavLink exact className="navLink" to={"/" + ROUTING_APP_2 + "/" + ROUTING_TAB_2} activeClassName="active">Par match</NavLink>
                </li>
                <li>
                  <NavLink className="navLink" to={"/" + ROUTING_APP_2 + "/" + ROUTING_TAB_1} activeClassName="active">Par offres</NavLink>
                </li>
              </ul>
            </div>

            <div className="chip" style={{ marginTop: 16 }}>
              <img src="/images/avatar_man.jpg" alt="Contact Person"/>
              John Doe
            </div>
          </div>
        </nav>
      </div>
    );
  }
}